<template>
  <div class="manager-list">
    <slot></slot>
    <ul class="manager-table">
      <li class="table-head header-split">
        <div class="row-content">
          <span class="name">{{ $t('名字') }}</span>
          <span class="position">{{ $t('职务') }}</span>
          <template v-if="isManagerDetail && market === 'hs'">
            <span class="number">{{ $t('年薪') }}</span>
            <span class="number">{{ $t('任职日期') }}</span>
            <span class="number">{{ $t('学历') }}</span>
            <span class="number">{{ $t('年龄') }}</span>
            <span class="number">{{ $t('更新日期') }}</span>
          </template>
          <span v-else class="number">{{ $t('持股数(万股)') }}</span>
        </div>
      </li>
      <li v-for="item in data" :key="item.managerName" class="table-body table-row">
        <div class="row-content" @click="toggleVisible(item)">
          <div class="name">
            <span>{{ item.managerName }}</span>
            <i
              :class="[
                'iconfont',
                visible === item.managerName + item.position ? 'icon-shangjiantou' : 'icon-xiajiantou'
              ]"
            ></i>
          </div>
          <div class="position">{{ item.position }}</div>
          <template v-if="isManagerDetail && market === 'hs'">
            <div class="number">
              {{ $digitjs(item.annualSalary).convert() }}
            </div>
            <div class="number">
              {{ $digitjs(item.entryDate).isNull() }}
            </div>
            <div class="number">
              {{ $digitjs(item.education).isNull() }}
            </div>
            <div class="number">
              {{ $digitjs(item.age).isNull() }}
            </div>
            <div class="number">
              {{ $digitjs(item.updateDate).isNull() }}
            </div>
          </template>
          <div v-else class="number">{{ $digitjs(item.holdingNumber).convert(2, 10000) }}</div>
        </div>
        <div class="other-info" v-show="visible === item.managerName + item.position" v-html="item.resume"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      visible: ''
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    isManagerDetail() {
      return this.$route.path.includes('/manager')
    }
  },
  methods: {
    toggleVisible({ managerName, position }) {
      if (this.visible === managerName + position) {
        this.visible = ''
      } else {
        this.visible = managerName + position
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-list {
  background: var(--bg-color-2);
  .manager-table {
    width: 100%;
    overflow-x: auto;

    .table-row {
      padding: 11px 0;
    }

    .row-content {
      position: relative;
      display: inline-flex;
      padding: 4px 0;
      .name {
        position: sticky;
        left: 0;
        padding: 0 var(--edge-padding);
        background: var(--bg-color-2);
        display: flex;
        justify-content: space-between;
        width: 90px;
        word-break: break-all;
        .iconfont {
          font-size: 9px;
          color: #d9d9d9;
          height: 20px;
          line-height: 20px;
        }
      }
      .position {
        width: 185px;
        padding: 0 6px;
      }
      .number {
        text-align: right;
        width: 90px;
      }

      .number:last-of-type {
        margin-right: var(--edge-padding);
      }
    }

    .other-info {
      line-height: 19px;
      padding: 12px;
      font-size: 13px;
      color: var(--font-color-3);
      background: var(--bg-color-9);
      border-radius: 4px;
      position: sticky;
      left: var(--edge-padding);
      margin-top: 20px;
      width: 355px;
    }

    .other-info:after {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 60px;
      border-bottom: 9px solid var(--bg-color-9);
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }

    .table-head {
      font-size: 15px;
      padding: 4px 0;
      color: var(--font-color-3);
    }
    .header-split {
      display: inline-block;
    }
    .table-body {
      display: inline-block;
      font-size: 14px;
      color: var(--font-color-1);
    }
  }
}
</style>
